<template>
  <div>
    <h1 style="margin: 20px;">您访问的页面不存在，将在 {{ data.time }} 秒后回到首页。</h1>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const data = reactive({
  time: 5
})
const timeoutId = setInterval(() => {
  if (data.time > 0) {
    data.time = data.time - 1
  }
  if (data.time <= 0) {
    router.push('/home')
    clearInterval(timeoutId)
  }
}, 1000)
</script>